import {h, Fragment} from "preact"
import { useActions, useAppStateSelector, pick } from "@nosto/preact"
import { useRef, useEffect, useState } from "preact/hooks";

export default function Searchbar() {
    const { loading, query, response } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response")
    )
    const { updateSearch } = useActions();
    const [ inputValue, setInputValue ] = useState("");
    const originalQuery = useRef(null);
    const docCount = response.products?.total ?? 0

    const handleInput = (event) => {
        setInputValue(event.target.value);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if(inputValue === query?.query || !inputValue || loading) return;
        updateSearch({ query: (inputValue) ? inputValue : originalQuery.current });
    };
    
    return (
        <div class="pt-[120px] flex flex-col items-center justify-center">
            <div class="flex flex-col items-center text-center gap-6 mb-10">
                <h1 class="h2 text-center">Search Results</h1>
                <form 
                    class="ns-search-form"
                    action="/search"
                    method="get"
                    role="search"
                    onSubmit={handleSubmit}
                >
                    <input
                        class="input-primary !rounded-[100px] min-w-[250px]"
                        id="ns-searchbar-input"
                        name="q"
                        type="search" 
                        spellCheck="false" 
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        placeholder="Search"
                        maxlength="200"
                        minlength="2"
                        value={inputValue}
                        onInput={handleInput}
                    />
                    <button class="button" type="submit">
                        Search
                    </button>
                </form>
                <p role="status">
                    {docCount > 0 
                        ? `${docCount} result${docCount === 1 ? '' : 's'} found for "${response.query}"`
                        : `No results found for "${response.query}". Check the spelling or use a different word or phrase.`
                    }
                </p>
            </div>
        </div>
    )
}
